import React from "react";
import Layout from "../../../components/layout";
import KubeNavbar from "../../../components/navbar-kube";
import CtaButton from "../../../components/signupCtaButton";

const Page = () => (
  <Layout title="Pricing - Kubernetes Monitoring" hasSubNav={true}>
    <KubeNavbar selection="pricing" />
    <section className="section apm-pricing-desc-section">
      <div className="container">
        <h1 className="has-text-centered has-text-weight-bold" style={{ fontSize: "2rem" }}>
          DripStat Kubernetes Pricing
        </h1>
        <table className="pricing-table">
          <tr>
            <th className="text-left">Instance Count</th>
            <th>Price per host</th>
          </tr>
          <tr>
            <td>Upto 10 Hosts</td>
            <td>Free</td>
          </tr>

          <tr>
            <td>&gt; 10 Hosts</td>
            <td>$10/month (paid annually)</td>
          </tr>
        </table>

        <div className="columns">
          <div className="column has-text-centered">
            <CtaButton />
          </div>
        </div>
      </div>
    </section>
  </Layout>
);

export default Page;
